import {apiClient} from 'core/apiClient';
import {ChecksAccessors, ChecksGridRawRow, ProductContentRawRow, ReceiptDetailRaw} from 'types';
import {
    ApiFilters,
    ApiPaging,
    ApiSortings,
    SimplePaginationContent,
    SimplePaginationContentRaw,
} from 'types/api';

export interface FetchParamsType {
    sortings: ApiSortings;
    filters: ApiFilters;
    paging: ApiPaging;
    docOrOwner?: string;
}

const RECEIPTS_URL = '/service/receipts';

let gridTokensCache: Record<number, string | null> = {
    0: null,
};

export function clearDocumentsGridCache(): void {
    gridTokensCache = {
        0: null,
    };
}

const modifyParams = (params: FetchParamsType) => {
    const id = params.filters.find((filter) => filter.id === ChecksAccessors.id);
    if (id && Array.isArray(id?.value)) {
        const flat = id.value[0];
        if (id?.value?.length) {
            // @ts-ignore
            id.value = flat;
        }
    }
};

export async function fetchChecksGrid(
    params: FetchParamsType,
): Promise<SimplePaginationContent<ChecksGridRawRow>> {
    const {pageSize, pageNumber} = params.paging;
    const token = gridTokensCache[pageNumber];
    if (token === undefined) throw new Error('Cache error');

    modifyParams(params);
    const mappedPaging = pageNumber === 0 ? {pageSize} : {pageRef: token};
    const responseData: SimplePaginationContentRaw<ChecksGridRawRow> = await apiClient
        .post(RECEIPTS_URL, {...params, paging: mappedPaging})
        .then((res) => res.data);

    if (responseData.nextPageRef) {
        gridTokensCache[pageNumber + 1] = responseData.nextPageRef;
    }

    return {
        content: responseData.data,
        hasNext: !!responseData.nextPageRef,
    };
}

export async function fetchReceiptsFilterState(params: FetchParamsType) {
    modifyParams(params);
    const {data} = await apiClient.post<Record<string, any>>(`${RECEIPTS_URL}/dict`, params);
    return data;
}

export async function fetchReceiptsDetail(id: string): Promise<ReceiptDetailRaw> {
    return (
        await apiClient.post(`${RECEIPTS_URL}/details`, {
            receiptId: id,
        })
    ).data;
}

export async function fetchReceiptProductsGrid(params: {
    receiptId: string;
    paging: ApiPaging;
    sortings: ApiSortings;
    filters: ApiFilters;
}): Promise<ProductContentRawRow[]> {
    return (await apiClient.post(`${RECEIPTS_URL}/details/products`, params))
        .data as ProductContentRawRow[];
}
